window.addEventListener('load', function(){
  setTimeout(function(){
    document.querySelectorAll('.wishlist-move-cart').forEach((form) => {
      form.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setTimeout( async function(){
          await card_atc();
        }, 2000);
      });
    });
    var form_1 = document.querySelector('#move_to_cart_all');
    if(form_1){ 
      form_1.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setTimeout( async function(){
          await card_atc();
        }, 2000);
      });
    }
  }, 1000);
  setTimeout(function(){
    document.querySelectorAll('.wishlist-move-cart').forEach((form) => {
      form.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setTimeout( async function(){
          await card_atc();
        }, 2000);
      });
    });
    var form_1 = document.querySelector('#move_to_cart_all');
    if(form_1){
      form_1.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setTimeout( async function(){
          await card_atc();
        }, 2000);
      });
    }
  }, 2000);
});